import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const NewRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewNewApplications.role,
    permissionsConfig.editRenewNewApplications.action,
    permissionsConfig.editRenewNewApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewNewApplications.role,
    permissionsConfig.deleteRenewNewApplications.action,
    permissionsConfig.deleteRenewNewApplications.type
  );

  return (
    <StatusApplication appStatus="8" title="Renew New" subTitle="Renew New" application_type="1" pageFrom="renew/new" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default NewRenewApplications